import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import type { OnChangeSetting } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { TextItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/textItemAttributes';

interface HeadlineProps {
  headline: DocumentItem<TextItemAttributes>;
  onChange: OnChangeSetting;
  handleChange: OnChangeSetting;
}

const Headline = ({ headline, onChange, handleChange }: HeadlineProps) => {
  const settingProps = { item: headline };

  return (
    <>
      <TextSetting
        description={__('The text must not exceed 40 characters')}
        onChange={onChange}
        maxLength={41}
        settingKey="content"
        title={__('Content')}
        width="318px"
        {...settingProps}
      />
      <DisplayOption
        title={__('Display headline')}
        onChange={handleChange}
        {...settingProps}
      />
    </>
  );
};

export default Headline;
